// Shared lexer — the single source of grammar truth on the frontend, consumed
// by both validateFormula and expressionToTokens. Mirrors the backend whitelist
// parser (docs/gotchas.md § "Dual-parser parity"). Variable codes are uppercase.

export type OperatorChar = "+" | "-" | "*" | "/";

export type LexToken =
  | { kind: "variable"; code: string }
  | { kind: "operator"; value: OperatorChar }
  | { kind: "openParen" }
  | { kind: "closeParen" };

// Returns null when a character outside the whitelist is encountered.
export function tokenize(expression: string): LexToken[] | null {
  const tokens: LexToken[] = [];
  let i = 0;
  while (i < expression.length) {
    const c = expression[i];
    if (c === " " || c === "\t" || c === "\n" || c === "\r") {
      i++;
    } else if (c === "(") {
      tokens.push({ kind: "openParen" });
      i++;
    } else if (c === ")") {
      tokens.push({ kind: "closeParen" });
      i++;
    } else if (c === "+" || c === "-" || c === "*" || c === "/") {
      tokens.push({ kind: "operator", value: c });
      i++;
    } else if (c >= "A" && c <= "Z") {
      let j = i + 1;
      while (
        j < expression.length &&
        ((expression[j] >= "A" && expression[j] <= "Z") ||
          (expression[j] >= "0" && expression[j] <= "9") ||
          expression[j] === "_")
      ) {
        j++;
      }
      tokens.push({ kind: "variable", code: expression.slice(i, j) });
      i = j;
    } else {
      return null;
    }
  }
  return tokens;
}
